export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const DEFAULT_PAGE_SIZE = 20;

export const HIDE_FOOTER_PAGE_SIZE = 10;
